<div id="staff-import" class="staff-import">
    <div class="staff-import-wrapper">
        <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
            <!-- Widget -->
            <div class="widget" fxFlex="100" fxFlex.gt-sm="30" fxFlex.gt-md="25" fxFlex.gt-lg="20">
                <app-staff-tree (empresaIdEmit)="selectTreeView($event)"></app-staff-tree>
            </div>
            <!-- / Widget -->
            <!-- Widget -->
            <div class="widget" fxFlex="100" fxFlex.gt-sm="70" fxFlex.gt-md="75" fxFlex.gt-lg="80">
                <div class="card-box">
                    <h2>Importar Plantilla</h2>
                    <div class="button-row">
                        <button mat-raised-button color="accent" (click)="openImportarEmpresa()">Especificar
                            empresas</button>
                        <button mat-raised-button color="accent" (click)="staffExcelImport()">Importar</button>
                    </div>
                </div>
                <div class="staff-import-content">
                    <div class="left">
                        <app-parameter-panel [appExcelColumnPanel]="appExcelColumnPanel" #appParameterPanel>
                        </app-parameter-panel>
                    </div>

                    <div class="right">
                        <app-excel-column-panel #appExcelColumnPanel></app-excel-column-panel>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>